export default [
  {
    path: '/stories/narrators',
    name: 'stories-narrators-index',
    role: ['admin', 'developer'],
    meta: {
      loadState: true,
      requiresAuth: true,
      isAuthView: false,
      parentGroup: 'stories',
    },
    component: () => import('@/views/stories/narrators/Index'),
  },
  {
    path: '/stories/narrators/create',
    name: 'stories-narrator-create',
    role: ['admin', 'developer'],
    meta: {
      loadState: true,
      requiresAuth: true,
      isAuthView: false,
      parentGroup: 'stories',
    },
    component: () => import('@/views/stories/narrators/Create'),
  },
  {
    path: '/stories/narrators/edit/:id',
    name: 'stories-narrator-edit',
    role: ['admin', 'developer'],
    meta: {
      loadState: true,
      requiresAuth: true,
      isAuthView: false,
      parentGroup: 'stories',
    },
    component: () => import('@/views/stories/narrators/Edit'),
  },
];
